// Malayalam: navigation menu, account chrome and role labels (field-facing screens). Keyed by the English source text.
export default {
  "Account": "അക്കൗണ്ട്",
  "Account menu": "അക്കൗണ്ട് മെനു",
  "Accounting": "അക്കൗണ്ടിംഗ്",
  "Administration": "അഡ്മിനിസ്ട്രേഷൻ",
  "Assets": "ആസ്തികൾ",
  "Assets & Inventory": "ആസ്തികളും ഇൻവെന്ററിയും",
  "Audit Scan": "ഓഡിറ്റ് സ്കാൻ",
  "Audit Schedules": "ഓഡിറ്റ് ഷെഡ്യൂളുകൾ",
  "Audits": "ഓഡിറ്റുകൾ",
  "Blind Counts": "ബ്ലൈൻഡ് കൗണ്ട്",
  "Blind Counts & Variance": "ബ്ലൈൻഡ് കൗണ്ടും വ്യത്യാസവും",
  "Close": "അടയ്ക്കുക",
  "Coming in Phase 2": "ഘട്ടം 2-ൽ വരുന്നു",
  "Custody": "കസ്റ്റഡി",
  "Custody & Movements": "കസ്റ്റഡിയും നീക്കങ്ങളും",
  "Dashboard": "ഡാഷ്ബോർഡ്",
  "Depreciation": "മൂല്യത്തകർച്ച",
  "Depreciation Runs": "മൂല്യത്തകർച്ച റണ്ണുകൾ",
  "Directory": "ഡയറക്ടറി",
  "Disposals": "ഡിസ്പോസലുകൾ",
  "Disposals & Write-Offs": "ഡിസ്പോസലും എഴുതിത്തള്ളലും",
  "Home": "ഹോം",
  "Incident Logging": "സംഭവം രേഖപ്പെടുത്തൽ",
  "Incidents": "സംഭവങ്ങൾ",
  "Integrations": "ഇന്റഗ്രേഷനുകൾ",
  "Interface language": "ഇന്റർഫേസ് ഭാഷ",
  "Inwarding": "ഇൻവേർഡിംഗ്",
  "Inwarding & Tagging": "ഇൻവേർഡിംഗും ടാഗിംഗും",
  "Language": "ഭാഷ",
  "Locations": "സ്ഥലങ്ങൾ",
  "Locations & Hierarchy": "സ്ഥലങ്ങളും ശ്രേണിയും",
  "Log In": "ലോഗിൻ ചെയ്യുക",
  "Log in": "ലോഗിൻ ചെയ്യുക",
  "Maintenance": "അറ്റകുറ്റപ്പണി",
  "Master Item Catalogue": "മാസ്റ്റർ ഐറ്റം കാറ്റലോഗ്",
  "More": "കൂടുതൽ",
  "Orders": "ഓർഡറുകൾ",
  "Physical Verification": "ഭൗതിക പരിശോധന",
  "Plans": "പ്ലാനുകൾ",
  "Plans & Billing": "പ്ലാനുകളും ബില്ലിംഗും",
  "Properties": "പ്രോപ്പർട്ടികൾ",
  "Reconcile": "പൊരുത്തപ്പെടുത്തുക",
  "Reconciliation Console": "പൊരുത്തപ്പെടുത്തൽ കൺസോൾ",
  "Review billing": "ബില്ലിംഗ് പരിശോധിക്കുക",
  "Roles & Permissions": "റോളുകളും അനുമതികളും",
  "Room Kit Stamping": "റൂം കിറ്റ് സ്റ്റാമ്പിംഗ്",
  "Room Kits": "റൂം കിറ്റുകൾ",
  "Scan": "സ്കാൻ",
  "Schedules": "ഷെഡ്യൂളുകൾ",
  "Security": "സുരക്ഷ",
  "Sign Out": "സൈൻ ഔട്ട്",
  "Sign out": "സൈൻ ഔട്ട്",
  "Toggle navigation": "നാവിഗേഷൻ കാണിക്കുക/മറയ്ക്കുക",
  "User Directory": "ഉപയോക്തൃ ഡയറക്ടറി",
  "Work Orders": "വർക്ക് ഓർഡറുകൾ",
  "Admin": "അഡ്മിൻ",
  "Customer Admin": "കസ്റ്റമർ അഡ്മിൻ",
  "Property Manager": "പ്രോപ്പർട്ടി മാനേജർ",
  "Finance Controller": "ഫിനാൻസ് കൺട്രോളർ",
  "Auditor (read-only)": "ഓഡിറ്റർ (വായിക്കാൻ മാത്രം)",
  "Field User": "ഫീൽഡ് ഉപയോക്താവ്",
  "Storekeeper": "സ്റ്റോർകീപ്പർ",
  "Department Head": "വകുപ്പ് മേധാവി",
  "User": "ഉപയോക്താവ്",
};
